/* tslint:disable */
/* eslint-disable */
/**
 * FanFair Complete API
 * Complete API documentation for FanFair platform including both public and private endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EndpointValidationResponse } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { SampleEventResponse } from '../models';
// @ts-ignore
import type { SampleEventsResponse } from '../models';
// @ts-ignore
import type { SignatureValidationResponse } from '../models';
// @ts-ignore
import type { TestEndpointRequest } from '../models';
// @ts-ignore
import type { TestWebhookEventRequest } from '../models';
// @ts-ignore
import type { ValidateEndpointRequest } from '../models';
// @ts-ignore
import type { ValidateSignatureRequest } from '../models';
// @ts-ignore
import type { WebhookSigningInfoResponse } from '../models';
// @ts-ignore
import type { WebhookTestResponse } from '../models';
/**
 * WebhookTestingApi - axios parameter creator
 * @export
 */
export const WebhookTestingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get sample payload for a specific event type. Requires webhook:read scope.
         * @summary Get sample payload for a specific event type
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} eventType Webhook event type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSampleEvent: async (partnerId: string, eventType: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('getSampleEvent', 'partnerId', partnerId)
            // verify required parameter 'eventType' is not null or undefined
            assertParamExists('getSampleEvent', 'eventType', eventType)
            const localVarPath = `/api/v1/partners/{partnerId}/webhooks/sample-events/{eventType}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"eventType"}}`, encodeURIComponent(String(eventType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get sample event payloads for testing. Requires webhook:read scope.
         * @summary Get sample event payloads for testing
         * @param {string} partnerId Partner ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSampleEvents: async (partnerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('getSampleEvents', 'partnerId', partnerId)
            const localVarPath = `/api/v1/partners/{partnerId}/webhooks/sample-events`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get signing information for a webhook configuration. Requires webhook:read scope.
         * @summary Get signing information for a webhook configuration
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} webhookId Webhook configuration ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSigningInfo: async (partnerId: string, webhookId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('getSigningInfo', 'partnerId', partnerId)
            // verify required parameter 'webhookId' is not null or undefined
            assertParamExists('getSigningInfo', 'webhookId', webhookId)
            const localVarPath = `/api/v1/partners/{partnerId}/webhooks/{webhookId}/signing-info`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"webhookId"}}`, encodeURIComponent(String(webhookId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Test an arbitrary webhook endpoint URL (not necessarily configured). Requires webhook:write scope.
         * @summary Test an arbitrary webhook endpoint
         * @param {string} partnerId Partner ID (ULID)
         * @param {TestEndpointRequest} testEndpointRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testEndpoint: async (partnerId: string, testEndpointRequest: TestEndpointRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('testEndpoint', 'partnerId', partnerId)
            // verify required parameter 'testEndpointRequest' is not null or undefined
            assertParamExists('testEndpoint', 'testEndpointRequest', testEndpointRequest)
            const localVarPath = `/api/v1/partners/{partnerId}/webhooks/test-endpoint`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testEndpointRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send a test webhook for a specific event type to a webhook configuration. Requires webhook:write scope.
         * @summary Test webhook with specific event type
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} webhookId Webhook configuration ID (ULID)
         * @param {string} eventType Webhook event type to test
         * @param {TestWebhookEventRequest} [testWebhookEventRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testWebhookEventType: async (partnerId: string, webhookId: string, eventType: string, testWebhookEventRequest?: TestWebhookEventRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('testWebhookEventType', 'partnerId', partnerId)
            // verify required parameter 'webhookId' is not null or undefined
            assertParamExists('testWebhookEventType', 'webhookId', webhookId)
            // verify required parameter 'eventType' is not null or undefined
            assertParamExists('testWebhookEventType', 'eventType', eventType)
            const localVarPath = `/api/v1/partners/{partnerId}/webhooks/{webhookId}/test/{eventType}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"webhookId"}}`, encodeURIComponent(String(webhookId)))
                .replace(`{${"eventType"}}`, encodeURIComponent(String(eventType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testWebhookEventRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validate a webhook endpoint\'s health and configuration. Requires webhook:write scope.
         * @summary Validate a webhook endpoint\'s health and configuration
         * @param {string} partnerId Partner ID (ULID)
         * @param {ValidateEndpointRequest} validateEndpointRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateEndpoint: async (partnerId: string, validateEndpointRequest: ValidateEndpointRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('validateEndpoint', 'partnerId', partnerId)
            // verify required parameter 'validateEndpointRequest' is not null or undefined
            assertParamExists('validateEndpoint', 'validateEndpointRequest', validateEndpointRequest)
            const localVarPath = `/api/v1/partners/{partnerId}/webhooks/validate-endpoint`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateEndpointRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Help partners validate their signature implementation. Requires webhook:write scope.
         * @summary Help partners validate their signature implementation
         * @param {string} partnerId Partner ID (ULID)
         * @param {ValidateSignatureRequest} validateSignatureRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateSignature: async (partnerId: string, validateSignatureRequest: ValidateSignatureRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('validateSignature', 'partnerId', partnerId)
            // verify required parameter 'validateSignatureRequest' is not null or undefined
            assertParamExists('validateSignature', 'validateSignatureRequest', validateSignatureRequest)
            const localVarPath = `/api/v1/partners/{partnerId}/webhooks/validate-signature`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateSignatureRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebhookTestingApi - functional programming interface
 * @export
 */
export const WebhookTestingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebhookTestingApiAxiosParamCreator(configuration)
    return {
        /**
         * Get sample payload for a specific event type. Requires webhook:read scope.
         * @summary Get sample payload for a specific event type
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} eventType Webhook event type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSampleEvent(partnerId: string, eventType: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SampleEventResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSampleEvent(partnerId, eventType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhookTestingApi.getSampleEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get sample event payloads for testing. Requires webhook:read scope.
         * @summary Get sample event payloads for testing
         * @param {string} partnerId Partner ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSampleEvents(partnerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SampleEventsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSampleEvents(partnerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhookTestingApi.getSampleEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get signing information for a webhook configuration. Requires webhook:read scope.
         * @summary Get signing information for a webhook configuration
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} webhookId Webhook configuration ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSigningInfo(partnerId: string, webhookId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebhookSigningInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSigningInfo(partnerId, webhookId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhookTestingApi.getSigningInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Test an arbitrary webhook endpoint URL (not necessarily configured). Requires webhook:write scope.
         * @summary Test an arbitrary webhook endpoint
         * @param {string} partnerId Partner ID (ULID)
         * @param {TestEndpointRequest} testEndpointRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testEndpoint(partnerId: string, testEndpointRequest: TestEndpointRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebhookTestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testEndpoint(partnerId, testEndpointRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhookTestingApi.testEndpoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send a test webhook for a specific event type to a webhook configuration. Requires webhook:write scope.
         * @summary Test webhook with specific event type
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} webhookId Webhook configuration ID (ULID)
         * @param {string} eventType Webhook event type to test
         * @param {TestWebhookEventRequest} [testWebhookEventRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testWebhookEventType(partnerId: string, webhookId: string, eventType: string, testWebhookEventRequest?: TestWebhookEventRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebhookTestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testWebhookEventType(partnerId, webhookId, eventType, testWebhookEventRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhookTestingApi.testWebhookEventType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validate a webhook endpoint\'s health and configuration. Requires webhook:write scope.
         * @summary Validate a webhook endpoint\'s health and configuration
         * @param {string} partnerId Partner ID (ULID)
         * @param {ValidateEndpointRequest} validateEndpointRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateEndpoint(partnerId: string, validateEndpointRequest: ValidateEndpointRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EndpointValidationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateEndpoint(partnerId, validateEndpointRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhookTestingApi.validateEndpoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Help partners validate their signature implementation. Requires webhook:write scope.
         * @summary Help partners validate their signature implementation
         * @param {string} partnerId Partner ID (ULID)
         * @param {ValidateSignatureRequest} validateSignatureRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateSignature(partnerId: string, validateSignatureRequest: ValidateSignatureRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureValidationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateSignature(partnerId, validateSignatureRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhookTestingApi.validateSignature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WebhookTestingApi - factory interface
 * @export
 */
export const WebhookTestingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebhookTestingApiFp(configuration)
    return {
        /**
         * Get sample payload for a specific event type. Requires webhook:read scope.
         * @summary Get sample payload for a specific event type
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} eventType Webhook event type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSampleEvent(partnerId: string, eventType: string, options?: RawAxiosRequestConfig): AxiosPromise<SampleEventResponse> {
            return localVarFp.getSampleEvent(partnerId, eventType, options).then((request) => request(axios, basePath));
        },
        /**
         * Get sample event payloads for testing. Requires webhook:read scope.
         * @summary Get sample event payloads for testing
         * @param {string} partnerId Partner ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSampleEvents(partnerId: string, options?: RawAxiosRequestConfig): AxiosPromise<SampleEventsResponse> {
            return localVarFp.getSampleEvents(partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get signing information for a webhook configuration. Requires webhook:read scope.
         * @summary Get signing information for a webhook configuration
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} webhookId Webhook configuration ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSigningInfo(partnerId: string, webhookId: string, options?: RawAxiosRequestConfig): AxiosPromise<WebhookSigningInfoResponse> {
            return localVarFp.getSigningInfo(partnerId, webhookId, options).then((request) => request(axios, basePath));
        },
        /**
         * Test an arbitrary webhook endpoint URL (not necessarily configured). Requires webhook:write scope.
         * @summary Test an arbitrary webhook endpoint
         * @param {string} partnerId Partner ID (ULID)
         * @param {TestEndpointRequest} testEndpointRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testEndpoint(partnerId: string, testEndpointRequest: TestEndpointRequest, options?: RawAxiosRequestConfig): AxiosPromise<WebhookTestResponse> {
            return localVarFp.testEndpoint(partnerId, testEndpointRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Send a test webhook for a specific event type to a webhook configuration. Requires webhook:write scope.
         * @summary Test webhook with specific event type
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} webhookId Webhook configuration ID (ULID)
         * @param {string} eventType Webhook event type to test
         * @param {TestWebhookEventRequest} [testWebhookEventRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testWebhookEventType(partnerId: string, webhookId: string, eventType: string, testWebhookEventRequest?: TestWebhookEventRequest, options?: RawAxiosRequestConfig): AxiosPromise<WebhookTestResponse> {
            return localVarFp.testWebhookEventType(partnerId, webhookId, eventType, testWebhookEventRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Validate a webhook endpoint\'s health and configuration. Requires webhook:write scope.
         * @summary Validate a webhook endpoint\'s health and configuration
         * @param {string} partnerId Partner ID (ULID)
         * @param {ValidateEndpointRequest} validateEndpointRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateEndpoint(partnerId: string, validateEndpointRequest: ValidateEndpointRequest, options?: RawAxiosRequestConfig): AxiosPromise<EndpointValidationResponse> {
            return localVarFp.validateEndpoint(partnerId, validateEndpointRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Help partners validate their signature implementation. Requires webhook:write scope.
         * @summary Help partners validate their signature implementation
         * @param {string} partnerId Partner ID (ULID)
         * @param {ValidateSignatureRequest} validateSignatureRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateSignature(partnerId: string, validateSignatureRequest: ValidateSignatureRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureValidationResponse> {
            return localVarFp.validateSignature(partnerId, validateSignatureRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebhookTestingApi - object-oriented interface
 * @export
 * @class WebhookTestingApi
 * @extends {BaseAPI}
 */
export class WebhookTestingApi extends BaseAPI {
    /**
     * Get sample payload for a specific event type. Requires webhook:read scope.
     * @summary Get sample payload for a specific event type
     * @param {string} partnerId Partner ID (ULID)
     * @param {string} eventType Webhook event type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookTestingApi
     */
    public getSampleEvent(partnerId: string, eventType: string, options?: RawAxiosRequestConfig) {
        return WebhookTestingApiFp(this.configuration).getSampleEvent(partnerId, eventType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get sample event payloads for testing. Requires webhook:read scope.
     * @summary Get sample event payloads for testing
     * @param {string} partnerId Partner ID (ULID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookTestingApi
     */
    public getSampleEvents(partnerId: string, options?: RawAxiosRequestConfig) {
        return WebhookTestingApiFp(this.configuration).getSampleEvents(partnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get signing information for a webhook configuration. Requires webhook:read scope.
     * @summary Get signing information for a webhook configuration
     * @param {string} partnerId Partner ID (ULID)
     * @param {string} webhookId Webhook configuration ID (ULID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookTestingApi
     */
    public getSigningInfo(partnerId: string, webhookId: string, options?: RawAxiosRequestConfig) {
        return WebhookTestingApiFp(this.configuration).getSigningInfo(partnerId, webhookId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Test an arbitrary webhook endpoint URL (not necessarily configured). Requires webhook:write scope.
     * @summary Test an arbitrary webhook endpoint
     * @param {string} partnerId Partner ID (ULID)
     * @param {TestEndpointRequest} testEndpointRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookTestingApi
     */
    public testEndpoint(partnerId: string, testEndpointRequest: TestEndpointRequest, options?: RawAxiosRequestConfig) {
        return WebhookTestingApiFp(this.configuration).testEndpoint(partnerId, testEndpointRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send a test webhook for a specific event type to a webhook configuration. Requires webhook:write scope.
     * @summary Test webhook with specific event type
     * @param {string} partnerId Partner ID (ULID)
     * @param {string} webhookId Webhook configuration ID (ULID)
     * @param {string} eventType Webhook event type to test
     * @param {TestWebhookEventRequest} [testWebhookEventRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookTestingApi
     */
    public testWebhookEventType(partnerId: string, webhookId: string, eventType: string, testWebhookEventRequest?: TestWebhookEventRequest, options?: RawAxiosRequestConfig) {
        return WebhookTestingApiFp(this.configuration).testWebhookEventType(partnerId, webhookId, eventType, testWebhookEventRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validate a webhook endpoint\'s health and configuration. Requires webhook:write scope.
     * @summary Validate a webhook endpoint\'s health and configuration
     * @param {string} partnerId Partner ID (ULID)
     * @param {ValidateEndpointRequest} validateEndpointRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookTestingApi
     */
    public validateEndpoint(partnerId: string, validateEndpointRequest: ValidateEndpointRequest, options?: RawAxiosRequestConfig) {
        return WebhookTestingApiFp(this.configuration).validateEndpoint(partnerId, validateEndpointRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Help partners validate their signature implementation. Requires webhook:write scope.
     * @summary Help partners validate their signature implementation
     * @param {string} partnerId Partner ID (ULID)
     * @param {ValidateSignatureRequest} validateSignatureRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookTestingApi
     */
    public validateSignature(partnerId: string, validateSignatureRequest: ValidateSignatureRequest, options?: RawAxiosRequestConfig) {
        return WebhookTestingApiFp(this.configuration).validateSignature(partnerId, validateSignatureRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

